export const UPDATE_PAYMENT_STATUS = 'UPDATE_PAYMENT_STATUS';
export const PAYMENT_LIST_GATEWAYS = 'PAYMENT_LIST_GATEWAYS';